module.exports = __webpack_public_path__ + "img/7.89f20e8b.jpg";